import React, { useState } from "react";
import '../../Styles/PC/PCSidebar.css';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'; // Verifications
import ReportProblemIcon from '@mui/icons-material/ReportProblem'; // Complaints
import { useNavigate } from "react-router-dom";

function PCSidebar({ handleComponentSelect }) {
    const navigate = useNavigate();
    const [activeItem, setActiveItem] = useState('ProgrammeUsers');

    const menuItems = [
        { id: 'ProgrammeUsers', label: 'Programme Users', icon: 'PUsers.png' },
        { id: 'ProgrammeConfig', label: 'Programme Config', icon: 'PConfig.png' },
        { id: 'DiagnosticCenters', label: 'Diagnostic Centers', icon: 'PDiagnostics.png' },
        { id: 'WellnessProfessionals', label: 'Wellness Professionals', icon: 'PDoctors.png' },
    ];



    const onTabSelected = (tabId) => {
        sessionStorage.setItem('activeLink', tabId);

        // Update the active flag
        setActiveItem(tabId);

        // Navigate to the respective page
        navigate(`/PC/${tabId}`);


        handleComponentSelect(tabId)
    };

    return (
        <div className="pc-sidebar">
            {menuItems.map((item) => (
                <div
                    key={item.id}
                    className={`pc-sidebar-item ${activeItem === item.id ? 'active' : ''}`}
                    onClick={() => onTabSelected(item.id)}
                >
                    <div className="pc-sidebar-icon">
                        {
                            activeItem === item.id ? (
                                <img src={`./images/WellnessProgramIcons/active/${item.icon}`} className="iconsize" alt="" />
                            ) : (
                                <img src={`./images/WellnessProgramIcons/inactive/${item.icon}`} className="iconsize" alt="" />
                            )
                        }
                    </div>
                    <span className="pc-sidebar-label">{item.label}</span>
                </div>
            ))}
        </div>
    );
}

export default PCSidebar;